module.exports = __webpack_public_path__ + "img/m_logo_happytable.03ec4eb3.svg";